import { apiRequest } from './api';

export type OrgWatchKind = 'winner' | 'buyer';

/** A watched organisation (ADR 0009). */
export interface OrgWatch {
  id: string;
  tin: string;
  kind: OrgWatchKind;
  label: string | null;
  active: boolean;
  createdAt: string;
}

export function listWatches(): Promise<OrgWatch[]> {
  return apiRequest<OrgWatch[]>('/me/watches');
}

export function createWatch(input: {
  tin: string;
  kind: OrgWatchKind;
  label?: string;
}): Promise<OrgWatch> {
  return apiRequest<OrgWatch>('/me/watches', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function deleteWatch(id: string): Promise<void> {
  return apiRequest<void>(`/me/watches/${id}`, { method: 'DELETE' });
}
